import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { VoucherCodeDetailsPage } from './voucher-code-details.page';

const routes: Routes = [
  {
    path: '',
    component: VoucherCodeDetailsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VoucherCodeDetailsPageRoutingModule {}
